import { PropTypes } from 'prop-types';
import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

import CartSummary from '../CartSummary';
import CartSummaryMobileBar from './CartSummaryMobileBar';
import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import useViewer from '@hooks/useViewer';

Modal.setAppElement('body');

const CartSummaryContainerStyled = styled.div`
    padding: 16px 24px 20px 24px;
`;

const CartSummaryMobileDrawer = ({ navLabel, isOpen, onClose, onNavClick, setCartHasErrors }) => {
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });

    return (
        <Modal
            isOpen={isOpen}
            style={{
                overlay: modalStyles.overlay,
                content: modalStyles.content,
            }}
            closeTimeoutMS={300}
            onRequestClose={() => onClose()}
            shouldCloseOnOverlayClick={false}
        >
            <div className="ReactModal__Body" style={modalStyles.body}>
                <CartSummaryContainerStyled>
                    <CartSummary setCartHasErrors={setCartHasErrors} />
                </CartSummaryContainerStyled>

                <CartSummaryMobileBar
                    cart={cart}
                    isDrawerOpen
                    navLabel={navLabel}
                    onExpandToggleClick={() => onClose()}
                    onNavClick={() => onNavClick()}
                />
            </div>
        </Modal>
    );
};

const modalStyles = {
    overlay: {
        backgroundColor: 'rgba(52, 52, 52, .80)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        zIndex: 99999,
    },
    content: {
        border: 'none',
        borderRadius: 0,
        bottom: 'auto',
        left: 'auto',
        right: 'auto',
        top: 'auto',
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        width: '100%',
    },
    body: {
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
    },
};

CartSummaryMobileDrawer.propTypes = {
    navLabel: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onNavClick: PropTypes.func.isRequired,
    setCartHasErrors: PropTypes.func,
};

export default CartSummaryMobileDrawer;
